import { createSlice } from "@reduxjs/toolkit";

const dataloadSlice = createSlice({
  name: "dataload",
  initialState: { selectedDataload: {}, list: [] },
  reducers: {
    setSelectedDataload: (state, action) => {
      return { ...state, selectedDataload: action.payload };
    },
    addDataloadList: (state, action) => {
      return { ...state, list: action.payload };
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = dataloadSlice;

// Extract and export each action creator by name
export const { setSelectedDataload, addDataloadList } = actions;

// Export the reducer, either as a default or named export
export default reducer;
